import { render, staticRenderFns } from "./SingleTerm.vue?vue&type=template&id=066084a9&scoped=true&"
import script from "./SingleTerm.vue?vue&type=script&lang=js&"
export * from "./SingleTerm.vue?vue&type=script&lang=js&"
import style0 from "./SingleTerm.vue?vue&type=style&index=0&id=066084a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066084a9",
  null
  
)

export default component.exports